export default "__VITE_ASSET__Bkxa8O7E__"